export {
  FeatureNewCarOffers as default,
  getStaticProps,
} from '@cinch-nx/feature-new-car-offers'
